import { gql } from '@apollo/client'

export const PROFILE_TOKEN = gql`
  query ProfileToken($idToken: String, $userId: String) {
    getProfileToken(idToken: $idToken, userId: $userId)
  }
`
